import React, { useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config";

function AddChild({ national_id, onChildAdded }) {
  const [childName, setChildName] = useState("");
  const [childDob, setChildDob] = useState("");
  const [childStatus, setChildStatus] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!childName || !childDob || !childStatus || !national_id) {
      setError("All fields are required!");
      return;
    }

    const newChild = {
      full_name: childName,
      date_of_birth: childDob,
      status: childStatus,
      parent_national_id: national_id,
    };

    console.log("Sending data:", newChild);

    try {
      const response = await axios.post(
        `${API_BASE_URL}/child/register`,
        newChild
      );
      console.log("Response:", response.data);
      onChildAdded(response.data);

      // Clear form after successful submission
      setChildName("");
      setChildDob("");
      setChildStatus("");
      setError(null);
    } catch (error) {
      console.error("Error adding child:", error.response?.data || error.message);
      setError(error.response?.data?.message || "Failed to add child");
    }
  };

  return (
    <div className="max-w-lg mx-auto mt-6 bg-white rounded-lg shadow-md overflow-hidden" style={{ width: "90%" }}>
      <div className="px-4 py-5 sm:px-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900">Add Child</h3>
      </div>
      {error && <p className="text-red-500 text-center">{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="px-4 py-5 sm:p-6">
          <div className="grid grid-cols-6 gap-6">
            {/* Child Name */}
            <div className="col-span-6 sm:col-span-3">
              <label htmlFor="childName" className="block text-sm font-medium text-gray-700">
                Child Name
              </label>
              <input
                type="text"
                id="childName"
                value={childName}
                onChange={(e) => setChildName(e.target.value)}
                className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>

            {/* Date of Birth */}
            <div className="col-span-6 sm:col-span-3">
              <label htmlFor="childDob" className="block text-sm font-medium text-gray-700">
                Date of Birth
              </label>
              <input
                type="date"
                id="childDob"
                value={childDob}
                onChange={(e) => setChildDob(e.target.value)}
                className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>

            {/* Status */}
            <div className="col-span-6 sm:col-span-3">
              <label htmlFor="childStatus" className="block text-sm font-medium text-gray-700">
                Status (Yarakiriwe?)
              </label>
              <select
                id="childStatus"
                value={childStatus}
                onChange={(e) => setChildStatus(e.target.value)}
                className="mt-1 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              >
                <option value="">Select</option>
                <option value="Yarakiriwe">Yes</option>
                <option value="Ntarakirwa">No</option>
              </select>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
          <button type="submit" className="px-4 py-2 bg-[#164E63] text-[#ADC2CB] text-sm font-medium rounded-md shadow-sm hover:bg-[#164E63]">
            Add Child
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddChild;